import { css as s } from "styled-components";
const p = {
  base: ({ theme: a }) => /* @__PURE__ */ s([
    "position:relative;height:",
    ";margin:",
    " auto -",
    " auto;top:-",
    ";",
    "{height:",
    ";top:-",
    ";margin-bottom:-",
    ";}",
    "{height:",
    ";top:-",
    ";margin-bottom:-",
    ";}"
  ], a.space.sm, a.space.xs, a.space.sm, a.space.sm, a.breakpoints.mq.tabletMin, a.space.md, a.space.md, a.space.md, a.breakpoints.mq.desktopMin, a.space.lg, a.space.lg, a.space.lg)
};
export {
  p as default
};
